// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"949":"7c39cf97","5842":"2cb270bd"}[chunkId] + ".chunk.css";
};